
    import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
    import AuthenticatorAppCards from '@/app/settings/components/authenticator-app-cards.vue'
    import QrCodeDisplay from '@/app/settings/components/qr-code-display.vue'
    import OtpVerificationForm from '@/app/settings/components/otp-verification-form.vue'
    import LockoutOverlay from '@/app/settings/components/lockout-overlay.vue'
    import { AddressStyleTranslationMixin } from '@/app/common/helpers/address-style-translation'

    @Component({
        components: {
            AuthenticatorAppCards,
            QrCodeDisplay,
            OtpVerificationForm,
            LockoutOverlay
        },
        mixins: [AddressStyleTranslationMixin]
    })
    export default class TotpSetupStepper extends Vue {
        @Prop({ type: Number, default: 1 }) step!: number
        @Prop({ type: Boolean, default: false }) loading!: boolean
        @Prop({ type: String, default: '' }) qrCode!: string
        @Prop({ type: Array, default: () => ['', '', '', '', '', ''] }) value!: string[]

        get otpDigits(): string[] {
            return this.value
        }

        set otpDigits(val: string[]) {
            this.$emit('input', val)
        }
        @Prop({ type: String, default: '' }) codeError!: string
        @Prop({ type: Boolean, default: false }) codeErrorActive!: boolean
        @Prop({ type: Number, default: 3 }) attemptsRemaining!: number
        @Prop({ type: Number, default: 4 }) maxAttempts!: number
        @Prop({ type: Boolean, default: false }) isLockedOut!: boolean
        @Prop({ type: Number, default: 0 }) lockoutCountdown!: number
        @Prop({ type: Number, default: 0 }) lockoutDuration!: number

        currentStep = 1

        @Watch('step')
        onStepChange(newStep: number) {
            this.currentStep = newStep
        }

        @Watch('currentStep')
        onCurrentStepChange(newStep: number) {
            this.$emit('update:step', newStep)
            if (newStep === 3 && !this.isLockedOut) {
                // Delay focus until after stepper transition animation completes
                setTimeout(() => {
                    const otpVerificationForm = this.$refs.otpVerificationForm as OtpVerificationForm
                    if (otpVerificationForm && otpVerificationForm.focus) {
                        otpVerificationForm.focus()
                    }
                }, 350)
            }
        }

        mounted() {
            this.currentStep = this.step
        }

        focus(): void {
            const otpVerificationForm = this.$refs.otpVerificationForm as OtpVerificationForm | undefined
            if (otpVerificationForm) {
                otpVerificationForm.focus()
            }
        }
    }
